import { Text } from '../..'
import { ErrorBlockProps } from './props'
import { StyledErrorBlock } from './styles'
import { ReactElement } from 'react'

const ErrorBlock = ({ errorText, ...props }: ErrorBlockProps): ReactElement => (
    <StyledErrorBlock {...props}>
        <Text>{errorText}</Text>
    </StyledErrorBlock>
)

export default ErrorBlock

export { StyledErrorBlock }
